/*
  Just Tattoos — product page controller. Plain ES2020, defer, PDP only.
  Progressive: with JS off the main image is the first skin-tone mockup (or the
  featured image), thumbnails are real links, the accordion is native <details>
  and the add-to-cart form posts normally. Add-to-cart AJAX is handled by
  assets/cart-drawer.js (it intercepts every form[action*="/cart/add"]), so this
  file must NOT add a second submit handler.
*/
(function () {
  'use strict';

  var doc = document;
  var JT = (window.JT = window.JT || {});

  function one(sel, root) { return (root || doc).querySelector(sel); }
  function all(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }

  function setImage(src, srcset) {
    var main = one('[data-gallery-main]');
    if (!main || !src) return;
    main.src = src;
    if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
  }

  function markActive(list, active) {
    list.forEach(function (el) {
      var on = el === active;
      el.classList.toggle('is-active', on);
      if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  doc.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (thumb) {
      event.preventDefault();
      setImage(thumb.getAttribute('data-media-src'), thumb.getAttribute('data-media-srcset'));
      markActive(all('[data-thumb]'), thumb);
      markActive(all('[data-skin-tone]'), null);
      return;
    }
    var swatch = event.target.closest('[data-skin-tone]');
    if (swatch) {
      event.preventDefault();
      setImage(swatch.getAttribute('data-swatch-src'), swatch.getAttribute('data-swatch-srcset'));
      markActive(all('[data-skin-tone]'), swatch);
      markActive(all('[data-thumb]'), null);
    }
  });

  doc.addEventListener('click', function (event) {
    if (event.target.closest('[data-pdp-qty-increase]')) {
      var incInput = one('[data-pdp-qty-input]');
      if (incInput) incInput.value = Math.max(1, (parseInt(incInput.value, 10) || 1) + 1);
      return;
    }
    if (event.target.closest('[data-pdp-qty-decrease]')) {
      var decInput = one('[data-pdp-qty-input]');
      if (decInput) decInput.value = Math.max(1, (parseInt(decInput.value, 10) || 1) - 1);
    }
  });

  doc.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || !radio.matches || !radio.matches('[data-variant-radio]')) return;
    var idInput = one('[data-variant-id]');
    if (idInput) idInput.value = radio.value;
    var addBtn = one('[data-pdp-add]');
    if (addBtn) addBtn.disabled = radio.disabled;
  });

  var lightbox = one('[data-zoom-lightbox]');
  function openZoom(src, alt) {
    if (!lightbox) return;
    var img = one('[data-zoom-image]', lightbox);
    if (img) { img.src = src; img.alt = alt || ''; }
    lightbox.setAttribute('data-open', 'true');
    lightbox.setAttribute('aria-hidden', 'false');
    doc.body.classList.add('is-lightbox-open');
    var close = one('[data-zoom-close]', lightbox);
    if (close) close.focus();
  }
  function closeZoom() {
    if (!lightbox) return;
    lightbox.setAttribute('data-open', 'false');
    lightbox.setAttribute('aria-hidden', 'true');
    doc.body.classList.remove('is-lightbox-open');
  }
  doc.addEventListener('click', function (event) {
    if (event.target.closest('[data-zoom]')) {
      var main = one('[data-gallery-main]');
      if (main) openZoom(main.currentSrc || main.src, main.alt);
      return;
    }
    if (event.target.closest('[data-zoom-close]')) { closeZoom(); return; }
    if (event.target === lightbox) closeZoom();
  });
  doc.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && lightbox && lightbox.getAttribute('data-open') === 'true') closeZoom();
  });

  function tagBuyNow() {
    all('.shopify-payment-button__button').forEach(function (btn) { btn.setAttribute('data-testid', 'buy-it-now'); });
  }

  function scrollRail(direction) {
    var rail = one('[data-related-rail]');
    if (!rail) return;
    rail.scrollBy({ left: direction * rail.clientWidth * 0.8, behavior: 'smooth' });
  }
  doc.addEventListener('click', function (event) {
    if (event.target.closest('[data-related-prev]')) { scrollRail(-1); return; }
    if (event.target.closest('[data-related-next]')) scrollRail(1);
  });

  function loadRelated() {
    var section = one('[data-related-section]');
    if (!section) return;
    var url = section.getAttribute('data-url');
    var rail = one('[data-related-rail]', section);
    if (!url || !rail || rail.children.length > 0) return;
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var fresh = parsed.querySelector('[data-related-rail]');
        if (fresh && fresh.children.length > 0) rail.innerHTML = fresh.innerHTML;
        else section.hidden = true;
      })
      .catch(function () { section.hidden = true; });
  }

  /* Sticky mobile add-to-cart: shown (under 768px, CSS) once the main Add to Cart
     button has scrolled past the top of the viewport. The sticky button clicks the
     real button, so the same form / cart-drawer.js handler runs. */
  function initSticky() {
    var bar = one('[data-pdp-sticky]');
    var mainBtn = one('[data-pdp-add]');
    var stickyBtn = bar && one('[data-pdp-sticky-add]', bar);
    if (!bar || !mainBtn || !stickyBtn) return;

    stickyBtn.addEventListener('click', function () {
      if (!mainBtn.disabled) mainBtn.click();
    });

    function syncLabel() {
      var label = one('[data-sticky-label]', bar);
      var price = one('[data-price]');
      var priceText = price ? price.textContent.trim() : '';
      var priceOut = one('[data-sticky-price]', bar);
      if (priceOut && priceText) priceOut.textContent = priceText;
      stickyBtn.disabled = mainBtn.disabled;
      if (!label) return;
      if (mainBtn.disabled) label.textContent = stickyBtn.getAttribute('data-label-sold-out') || label.textContent;
      else if (priceText) label.textContent = (stickyBtn.getAttribute('data-label-template') || '').replace('__PRICE__', priceText) || label.textContent;
    }
    doc.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-variant-radio]')) syncLabel();
    });

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      bar.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
    }).observe(mainBtn);
  }

  function init() { tagBuyNow(); loadRelated(); initSticky(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
